import { PublicClientApplication, InteractionRequiredAuthError, EventType } from '@azure/msal-browser';
import axios from 'axios';
import { APPS_MONITORING_SCOPE, GRAPH_SCOPE, CORESERVICES_ACC_SCOPE, CORESERVICES_PRD_SCOPE, CORESERVICES_DEV_SCOPE, XOM_CONTACTS_SCOPE } from '../constants';
import { getHostname } from '../shared/util';

const config = {
    auth: {
        clientId: 'd7959747-ce9a-4d50-a1ba-a045787ecf63',
        authority: 'https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com/',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['user.read'],
};

export const msalInstance = new PublicClientApplication(config);

msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        msalInstance.setActiveAccount(event.payload.account);
    }
});

axios.interceptors.request.use(
    async (config) => {
        const hostname = getHostname(config.url);
        let scopes;
        switch (hostname) {
            case 'application-monitoring.azurewebsites.net':
                scopes = [APPS_MONITORING_SCOPE];
                break;
            case 'core.mobility-acc.xom.cloud':
                scopes = [CORESERVICES_ACC_SCOPE];
                break;
            case 'core.mobility-dev.xom.cloud':
                scopes = [CORESERVICES_DEV_SCOPE];
                break;
            case 'core.mobility.xom.cloud':
                scopes = [CORESERVICES_PRD_SCOPE];
                break;
            case 'graph.microsoft.com':
                scopes = [GRAPH_SCOPE];
                break;
            case 'xom-contacts-api-prd.apps.xom.cloud':
                scopes = [XOM_CONTACTS_SCOPE];
                break;
            default:
                scopes = [];
        }

        const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
        if (account) {
            const request = { scopes: scopes.length ? scopes : loginRequest.scopes, account };
            try {
                const response = await msalInstance.acquireTokenSilent(request);
                config.headers.Authorization = `Bearer ${response.accessToken}`;
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    await msalInstance.acquireTokenRedirect(request);
                } else {
                    throw error;
                }
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
